// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/MUI";

// Data
import axios from "axios";
import { withAuthContext } from "context/Auth";
import { useEffect, useMemo, useState } from "react";
import MDBadge from "components/MDBadge";
import ServiceOfferedIcon from "assets/images/bg-profile.jpeg";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import ImageCloud from "../../link";

function Tables({ AdminRole, Token }) {
	const { serviceId } = useParams();
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 10, totalPages: 0 });
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);

	// ✅ Memoized columns
	const columns = useMemo(
		() => [
			{
				headerName: "",
				field: "Icon",
				flex: 1,
				renderCell: ({ row: a }) => (
					<img
						src={a?.Icon?.filename ? `${ImageCloud}/${a?.Icon?.filename}` : ServiceOfferedIcon}
						style={{
							width: "50px",
							height: "50px",
							borderRadius: "50px",
							border: "1px solid #000",
						}}
					/>
				),
			},
			{ headerName: "title", field: "title", flex: 1 },
			{
				headerName: "Fields",
				field: "Fields",
				flex: 1,
				valueGetter: ({ row: a }) => `${a?.Fields?.length || 0}`,
			},
			{
				headerName: "Service",
				field: "Service",
				flex: 1,
				valueGetter: ({ row: a }) => `${a?.Service?.length || 0}`,
			},
			{
				headerName: "Action",
				field: "action",
				flex: 1,
				renderCell: ({ row: a }) => (
					<MDBox>
						<MDBadge
							badgeContent={serviceId ? "Select Service" : "Edit"}
							color={"warning"}
							variant="gradient"
							size="sm"
							onClick={() => {
								if (serviceId) {
									navigate(`/ServiceAction/New/${a?._id}`);
								} else if (AdminRole === "superadmin") {
									navigate(`/ServiceOfferedAction/${a?._id}`);
								} else {
									swal({
										text: "There was some Error or You are not allowed for the action",
										button: { text: "Ok", closeModal: true },
										icon: "error",
										time: 3000,
									});
								}
							}}
						/>
					</MDBox>
				),
			},
		],
		[serviceId, AdminRole, navigate]
	);

	// ✅ Fetch service offered data
	const GetServiceOffereds = () => {
		const tokenHeader = Token || localStorage.getItem("accessToken") || localStorage.getItem("token");
		setIsLoading(true);
		axios
			.get(`${process.env.REACT_APP_PUBLIC_PATH}/GetAllServiceOffered?page=${currentPage}&limit=${itemsPerPage}`, {
				headers: { Authorization: `Bearer ${tokenHeader}` }
			})
			.then((res) => {
				if (res?.data?.status === 200) {
					setData(res?.data?.data);
					if (res?.data?.pagination) {
						setPagination(res?.data?.pagination);
					}
				} else {
					setError(res?.data?.message);
				}
			})
			.catch((err) => {
				setError(err?.message);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	useEffect(() => {
		GetServiceOffereds();
	}, [currentPage, itemsPerPage]);

	const handlePageChange = (newPage, newPageSize) => {
		if (newPageSize !== itemsPerPage) {
			setItemsPerPage(newPageSize);
			setCurrentPage(1);
		} else {
			setCurrentPage(newPage);
		}
	};

	// ✅ Memoized table
	const ServiceOfferedTable = useMemo(
		() => (
			<Card>
				<MDBox
					mx={2}
					mt={-3}
					py={3}
					px={2}
					variant="gradient"
					bgColor="info"
					borderRadius="lg"
					coloredShadow="info"
				>
					<Grid container style={{ width: "100%" }}>
						<Grid item xs={6}>
							<MDTypography variant="h6" color="white">
								Service Offered
							</MDTypography>
						</Grid>
						{AdminRole === "superadmin" && (
							<Grid
								item
								xs={6}
								style={{
									display: "flex",
									alignItems: "flex-end",
									justifyContent: "flex-end",
								}}
							>
								<MDBadge
									badgeContent="New"
									color="dark"
									variant="gradient"
									size="sm"
									onClick={() => navigate(`/ServiceOfferedAction/New`)}
								/>
							</Grid>
						)}
					</Grid>
				</MDBox>

			<MDBox pt={3}>
				{isLoading ? (
				<MDBox lineHeight={1} textAlign="center" py={3}>
					<MDTypography display="block" variant="caption" color="text" fontWeight="medium" fontSize="16px">
						Loading...
					</MDTypography>
				</MDBox>
			) : data.length > 0 ? (
				<DataTable 
					rows={data} 
					columns={columns} 
					paginationMode="server"
					serverPagination={{
						total: pagination?.total || 0,
						page: currentPage,
						limit: itemsPerPage,
						onPageChange: handlePageChange
					}}
				/>
				) : (
					<MDBox lineHeight={1} textAlign="center">
						<MDTypography
							display="block"
							variant="caption"
							color="text"
							fontWeight="medium"
							fontSize="20px"
						>
							{error ? error : "No Data Found"}
						</MDTypography>
					</MDBox>
				)}
			</MDBox>
		</Card>
	),
	[data, columns, AdminRole, error, navigate, isLoading, pagination, currentPage, itemsPerPage, handlePageChange]
);	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox pt={6} pb={3}>
				<Grid container spacing={6}>
					<Grid item xs={12}>
						{ServiceOfferedTable}
					</Grid>
				</Grid>
			</MDBox>
		</DashboardLayout>
	);
}

export default withAuthContext(Tables);
